module.exports = __webpack_public_path__ + "static/media/logo.b8503d26.png";